export function ArrowRight({ className = "w-3 h-3" }: { className?: string }) {
  return (
    <svg
      className={className}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.51788 2.09082L13.7588 7.33172C14.0804 7.65333 14.0804 8.17476 13.7588 8.49637L8.51788 13.7373C8.19628 14.0589 7.67485 14.0589 7.35324 13.7373C7.03163 13.4157 7.03163 12.8942 7.35324 12.5726L11.1883 8.73758L0 8.73758L0 7.09052L11.1883 7.09052L7.35324 3.25546C7.03163 2.93385 7.03163 2.41242 7.35324 2.09082C7.67485 1.76921 8.19628 1.76921 8.51788 2.09082Z"
        fill="currentColor"
      />
    </svg>
  );
}
